import { Form } from 'antd';
import styled from 'styled-components';

export const StyledForm = styled(Form)`
    #password_help {
        margin-bottom: 10px;
    }
`;
